const lanes = [
  { from: "CLT", to: "ATL", equip: "Dry Van", rate: "2.45" },
  { from: "CLT", to: "DAL", equip: "Reefer", rate: "2.90" },
  { from: "ATL", to: "MIA", equip: "Dry Van", rate: "2.30" },
  { from: "CLT", to: "CHI", equip: "Flatbed", rate: "3.10" },
  { from: "GSO", to: "BNA", equip: "Dry Van", rate: "2.55" },
  { from: "CLT", to: "JAX", equip: "Reefer", rate: "2.75" },
  { from: "RDU", to: "CAE", equip: "Power Only", rate: "2.20" },
  { from: "CLT", to: "HOU", equip: "Flatbed", rate: "2.95" },
];

export const LaneTicker = () => (
  <div className="border-b border-white/10 bg-[#0E0E0E] py-3.5 overflow-hidden" data-testid="lane-ticker">
    <div className="marquee-track-reverse flex w-max whitespace-nowrap items-center">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0 items-center">
          <span className="pl-6 pr-2 font-mono text-[9px] uppercase tracking-[0.3em] text-neutral-600">
            Sample market lanes
          </span>
          {lanes.map((l, i) => (
            <span key={`${half}-${i}`} className="flex items-center font-mono text-[11px] tracking-[0.12em]">
              <span className="text-white/25 px-2">·</span>
              <span className="px-3 text-neutral-400 uppercase">{l.from} → {l.to}</span>
              <span className="text-neutral-600 text-[9px] uppercase tracking-[0.25em]">{l.equip}</span>
              <span className="px-3 text-white font-semibold">
                ${l.rate}<span className="text-neutral-500 font-normal">/mi</span>
              </span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
